module.exports = __webpack_public_path__ + "img/mt.svg";